export default "__VITE_ASSET__DzrpWqgH__"